module.exports = __webpack_public_path__ + "static/media/wejdz.d93e8d80.jpg";